const EventsService = function ($rootScope) {
  "ngInject"

  const broadcast = (eventName, args) => {
    console.log("Broadcast::", eventName, "::Args::", args);
    $rootScope.$broadcast(eventName, args);
  }
  
  const listen = (eventName, handler) => $rootScope.$on(eventName, handler);
  
  return { broadcast, listen };
};

export default EventsService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/events.service.js
 **/